import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import TagCell from '@/onenetwork/components/datatable/TagCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import { COMMISSION_API, CONTRACT_API } from '@/modules/contract/constants/contract.api.uri.const.ts'
import { parseFilter } from '@/utils/filterHelper.ts'
import CodeCell from '@/onenetwork/components/datatable/CodeCell.vue'
import {markRaw} from 'vue'
import {parseDataTable} from '@/modules/contract/helper/commission_listing.ts'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import CommissionUserCell from '@/modules/contract/components/Table/CommissionUserCell.vue'
import CommissionBankCell from '@/modules/contract/components/Table/CommissionBankCell.vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum ContractCommissionListActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface ContractCommissionListStore {
  action_type: ContractCommissionListActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Array<{
    key: string,
    type: string,
    label: string,
    placeholder: string,
    value: any,
    options?: Array<{label: string, value: string}>
  }>,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useContractCommissionList = defineStore('contract.commission.list', {
  state: (): ContractCommissionListStore => ({
    action_type: ContractCommissionListActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'settled_date',
        type: 'date-range',
        label: 'Lọc theo ngày quyết toán',
        placeholder: 'Chọn ngày',
        value: '',
      },
      {
        key: 'code',
        type: 'taginput',
        label: 'Lọc theo mã HĐ',
        placeholder: 'Nhập mã HĐ',
        value: '',
      },
      {
        key: 'type',
        type: 'select-multiple',
        label: 'Lọc theo loại hoa hồng',
        placeholder: 'Chọn phân loại',
        value: '',
        options: [
          { label: 'Quỹ & Hỗ trợ', value: ""},
          { label: 'MG bán', value: "S"},
          { label: 'Cấp trên MG Bán', value: "S_SUP"},
          { label: 'GD MG Bán', value: "S_ROOT"},
          { label: 'MG Mua', value: "B"},
          { label: 'Cấp trên MG Mua', value: "B_SUP"},
          { label: 'GD MG Bán', value: "B_ROOT"},
        ],
      },
      {
        key: 'progress',
        type: 'select-multiple',
        label: 'Lọc theo tình trạng',
        placeholder: 'Chọn tình trạng',
        value: '',
        options: [
          { value: 'waiting', label: "Chờ thanh toán"},
          { value: 'paid', label: "Đã thanh toán"},
        ],
      },
      {
        key: 'user',
        type: 'account-selector',
        label: 'Lọc theo tài khoản',
        placeholder: '',
        value: '',
      },
      {
        key: 'action_by',
        type: 'account-bo-selector',
        label: 'Người xử lý',
        placeholder: '',
        value: '',
      },

    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách hoa hồng',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        id: { label: 'ID', component: markRaw(CodeCell), class: '', visible: true, sort: false, config: {} },
        code: { label: 'Mã HĐ', component: markRaw(CodeCell), class: '', visible: true, sort: false, config: {} },
        status: { label: 'Trạng thái', component: markRaw(TagCell), class: '', visible: true, sort: false, config: {} },
        type: { label: 'Loại HH', component: markRaw(TagCell), class: '', visible: true, sort: false, config: {} },
        account: { label: 'Người nhận', component: markRaw(CommissionUserCell), class: '', visible: true, sort: false, config: {} },
        tax: { label: 'MST', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
        bankInfo: { label: 'Ngân hàng', component: markRaw(CommissionBankCell), class: '', visible: true, sort: false, config: {} },
        rate: { label: 'HH (%)', component: markRaw(NumberCell), class: '', visible: true, sort: false, config: { fixedNumber: 2, decimalSp: ',', thousandSp: '.'} },
        amount: { label: 'HH (₫)', component: markRaw(MoneyCell), class: '', visible: true, sort: false, config: {} },
        created_at: { label: 'Ngày cập nhật', component: markRaw(DateTimeCell), class: '', visible: true, sort: '', config: {} },
        action_by: { label: 'Người cập nhật', component: markRaw(TextCell), class: '', visible: true, sort: false, config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    },
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách hợp đồng',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = ContractCommissionListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changeFilter (key: string, value: any) {
      const filterItem = this.filter.find((item: {key: string}) => item.key === key)
      if (filterItem) {
        filterItem.value = value
        this.action_type = ContractCommissionListActionTypes.FILTERING
        this.uuid = uuid.v4()
      }
    },
    putFilter(key: string, value: any) {
      this.filter = this.filter.map((field) => {
        if (field.key === key) {
          return { ...field, value: value }
        }
        return field
      })
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = ContractCommissionListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.page = 1
      this.action_type = ContractCommissionListActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise(async (resolve, reject) => {
        try{
          this.action_type = ContractCommissionListActionTypes.FETCHING
          const _filter = {
            page: this.page,
            page_size: this.pageSize,
            sort: this.sortFilter,
            ...parseFilter(this.filter),
            relations: [
              'user', 'contract'
            ]
          }

          const res = await APIClient.get(COMMISSION_API, {
            params: _filter
          })
          const { data } = res.data
          this.data = {
            list: parseDataTable(data.data),
            totalRecords: data.total,
            totalPage: data.to,
          }
          this.action_type = ContractCommissionListActionTypes.FETCH_SUCCESS
          resolve(res)
        } catch (e) {
          this.action_type = ContractCommissionListActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
